import { render, staticRenderFns } from "./spr-processing.vue?vue&type=template&id=fa5e2a0c&scoped=true&"
import script from "./spr-processing.vue?vue&type=script&lang=js&"
export * from "./spr-processing.vue?vue&type=script&lang=js&"
import style0 from "./spr-processing.vue?vue&type=style&index=0&id=fa5e2a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5e2a0c",
  null
  
)

export default component.exports